import React from 'react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="w-full bg-deep-green py-20 px-4 text-white" data-id="element-174">
      <div className="max-w-3xl mx-auto text-center" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-176">
          <div className="text-6xl mb-6" data-id="element-177">🛡️</div>
          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-178">
            GARANTÍA PORTUGUÉS 360™ — 7 DÍAS
          </h2>

          <div className="space-y-2 text-lg md:text-xl text-green-50 mb-10 leading-relaxed font-medium" data-id="element-179">
            <p data-id="element-180">Abrís los 12 tomos. Revisás los 6 bonus.</p>
            <p data-id="element-181">Los usás en el aula si querés.</p>
            <p className="mt-4" data-id="element-182">Si en 7 días no es lo que esperabas:</p>
            <p className="text-gold font-bold text-2xl mt-2" data-id="element-183">
              Te devolvemos el 100%.
            </p>
            <p className="mt-4" data-id="element-184">Sin preguntas. Sin formularios. Sin drama.</p>
          </div>

          <div className="inline-block border border-gold/30 bg-black/20 rounded-lg px-6 py-4" data-id="element-185">
            <p className="text-gold font-bold text-sm md:text-base" data-id="element-186">
              Más de 500 docentes ya lo usan.
              <br data-id="element-187" />
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}